import FieldString_RenderEditableInlineInput from "../../../string/render/inline-editable/input-editable-inline"
import number_checkValueIsValid from "../../render/helpers/check-value-is-valid"

export default class FieldNumber_InlineEditableComponent extends FieldString_RenderEditableInlineInput {

    isValueValid(value?: any): boolean {
        return number_checkValueIsValid(this.props.field, value || this.value)
    }
}